"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GiftsHistoryListItem = _interopRequireDefault(require("./GiftsHistoryListItem"));

var _GiftsHistoryList = _interopRequireDefault(require("./GiftsHistoryList"));

var _ContactProfile = _interopRequireDefault(require("./ContactProfile"));

var _root = _interopRequireDefault(require("./store/root.epic"));

var _root2 = _interopRequireDefault(require("./store/root.reducer"));

var _needMoreInfo = require("./store/NeedMoreInfo/needMoreInfo.types");

var _LineProfile = _interopRequireDefault(require("./LineProfile"));

var ContactDetails = {
  epic: _root.default,
  reducer: _root2.default,
  GiftsHistoryListItem: _GiftsHistoryListItem.default,
  GiftsHistoryList: _GiftsHistoryList.default,
  ContactProfile: _ContactProfile.default,
  LineProfile: _LineProfile.default,
  actionTypes: {
    SEND_MORE_INFO_SUCCESS: _needMoreInfo.SEND_MORE_INFO_SUCCESS
  }
};
var _default = ContactDetails;
exports.default = _default;